
                import "css-modules://src_components_inputcheckbox"
                export default {"Main":"_0479c5","Svg":"_612cd4","PathCheckmark":"_4a10db","LabelText":"_4f669e","Input":"_4ab76c"}
            